import {
  AppBar,
  Box,
  Container,
  makeStyles,
  Theme,
  Toolbar,
} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import React from "react";

const useStyles = makeStyles((theme: Theme) => ({
  appbar: {},
  brand: {
    backgroundImage: `url('/assets/logos/bgf_logo.png')`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    width: theme.spacing(24),
    minHeight: theme.spacing(10),
    marginRight: "auto",
  },
  search: {
    // marginLeft: "auto",
    // paddingLeft: theme.spacing(1),
    // paddingRight: theme.spacing(1),
  },
  navButton: { textTransform: "none", marginRight: theme.spacing(2) },
  loginButton: { color: theme.palette.common.white },
  toolbar: {
    height: theme.spacing(10),
    display: "flex",
  },
}));

interface Props {
  searchField?: React.ReactNode;
  children?: React.ReactNode;
}

export default function BasicHeader(props: Props): JSX.Element {
  const { children, searchField } = props;

  const classes = useStyles();

  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      className={classes.appbar}
    >
      <Toolbar className={classes.toolbar}>
        <Container>
          <Link href="/">
            <Box className={classes.brand} />
          </Link>
          {children}
          <Box className={classes.search}>{searchField}</Box>
        </Container>
      </Toolbar>
    </AppBar>
  );
}
